import * as React from 'react'

import { clsx } from 'clsx'

import { AllChannelsIcon } from '@buffer-mono/popcorn'

import styles from './AllChannelsAvatar.module.css'

type AllChannelsAvatarProps = {
  /**
   * Optional class name applied to the avatar wrapper. Use for positioning
   * or layout overrides only — do NOT use to change the visual (border,
   * size, shape). The component locks those down on purpose so every "all
   * channels" tile in the product renders identically.
   */
  className?: string
}

/**
 * The shared "all channels" tile rendered next to page titles on Publish's
 * AllChannels view, Community's AllChannels view, and Insights' AllChannels
 * view.
 *
 * Visuals follow Publish's existing implementation, which is the source
 * of truth for this tile: 48px circular in legacy theme, 42px
 * rounded-square in Visual Refresh, with a 24px AllChannels glyph
 * centred inside.
 *
 * Closed by design — only `className` is accepted. The whole point of this
 * component is to remove per-page divergence in the tile's visual.
 */
const AllChannelsAvatar = React.forwardRef<
  HTMLDivElement,
  AllChannelsAvatarProps
>(({ className }, forwardedRef) => {
  return (
    <div ref={forwardedRef} className={clsx(styles.root, className)}>
      <AllChannelsIcon size={24} />
    </div>
  )
})

AllChannelsAvatar.displayName = 'AllChannelsAvatar'

export { AllChannelsAvatar }
export type { AllChannelsAvatarProps }
